import { i18n } from "translate/i18n";

export const premiumApproved = i18n.t("messages.premiumApproved");
export const accessPremium = i18n.t("messages.accessPremium");
export const createFirstChallenge = i18n.t("messages.createFirstChallenge");
